import React, {Component} from 'react';
import {
    Platform,
    StyleSheet,
    Text,
    View,
    TouchableOpacity,
    StatusBar,
    TextInput,
    I18nManager,
    ToastAndroid,
    FlatList,
    ActivityIndicator,
    KeyboardAvoidingView
} from 'react-native';
import Colors, {colorDark, colorPrimary} from "../../../../tools/Colors"
import {moderateScale} from "../../../../tools/Scaling";
import {connect} from "react-redux";
import HMTextView from "../../../../customviews/HMTextView";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import Ping from "react-native-ping";
import HMIcon from "../../../../customviews/HMIcon";
import HMAlert from "../../../../customviews/HMAlert";
import i18n from "../../../../I18n/i18n";
import * as NavigationService from "../../../../redux/NavigationService";
//import Modal from "react-native-modal";

let container = null;

class TestConnectionScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        this.state = {
            noInternet: false,
            list: [
                {
                    id: 1,
                    success: "اتصال با مودم برقرار است (ping 192.168.1.1)",
                    error: "اتصال با مودم برقرار نیست (ping 192.168.1.1)",
                    message: "دسترسی به مودم  (ping 192.168.1.1) Wi-Fi",
                    type: "",
                    address: "192.168.1.1",
                    description: "",

                    type1: "isLoading",
                    ms1: null,
                    type2: "isLoading",
                    ms2: null,
                    type3: "isLoading",
                    ms3: null,
                    type4: "isLoading",
                    ms4: null,


                },
                {
                    success: "اتصال با شبکه ساتیا برقرار است  (ping 172.18.248.4)",
                    error: "اتصال با شبکه ساتیا برقرار نیست  (ping 172.18.248.4)",
                    message: "دسترسی به شبکه ساتیا  (ping 172.18.248.4)",
                    type: "",
                    address: "172.18.248.4",
                    description: "",


                    type1: "isLoading",
                    ms1: null,
                    type2: "isLoading",
                    ms2: null,
                    type3: "isLoading",
                    ms3: null,
                    type4: "isLoading",
                    ms4: null,
                },
                {
                    success: "سایت ساتیا با موفقیت باز شد",
                    error: "خطا در باز کردن سایت ساتیا",
                    message: "باز کردن سایت ساتیا",
                    type: "",
                    address: "www.satia.co",
                    description: "",


                    type1: "isLoading",
                    ms1: null,
                    type2: "isLoading",
                    ms2: null,
                    type3: "isLoading",
                    ms3: null,
                    type4: "isLoading",
                    ms4: null,

                },
                {
                    success: "اتصال با سرور گوگل برقرار است (ping 8.8.8.8)",
                    error: "اتصال با سرور گوگل برقرار نیست (ping 8.8.8.8)",
                    message: "دسترسی به سرور گوگل (ping 8.8.8.8)",
                    type: "",
                    address: "8.8.8.8",
                    description: "",


                    type1: "isLoading",
                    ms1: null,
                    type2: "isLoading",
                    ms2: null,
                    type3: "isLoading",
                    ms3: null,
                    type4: "isLoading",
                    ms4: null,
                },
                {
                    success: "اتصال با دامنه yahoo.com برقرار است",
                    error: "اتصال با دامنه yahoo.com برقرار نیست",
                    message: "دسترسی به دامنه yahoo.com",
                    type: "",
                    address: "www.yahoo.com",
                    description: "",


                    type1: "isLoading",
                    ms1: null,
                    type2: "isLoading",
                    ms2: null,
                    type3: "isLoading",
                    ms3: null,
                    type4: "isLoading",
                    ms4: null,

                },

                // {
                //     success: "سایت fb با موفقیت باز شد",
                //     error: "خطا در باز کردن سایت fb",
                //     message: "باز کردن سایت fb",
                //     type: "",
                //     address: "fb.com",
                //     description: ""
                // },  {
                //     success: "سایت g با موفقیت باز شد",
                //     error: "خطا در باز کردن سایت fb",
                //     message: "باز کردن سایت fb",
                //     type: "",
                //     address: "192.168.168.223",
                //     description: ""
                // },  {
                //     success: "سایت g با موفقیت باز شد",
                //     error: "خطا در باز کردن سایت fb",
                //     message: "باز کردن سایت fb",
                //     type: "",
                //     address: "192.168.168.223:8000",
                //     description: ""
                // },
            ]
        }

    }

    componentWillMount() {

        this._isMounted = true;

        this.setType(this.state.list[0], 0, "loading")


    }

    componentWillUnmount() {
        this._isMounted = false;

    }

    render() {

        return (
            <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                      enabled={Platform.OS === "ios"}>
                    <HMActionBarSatia
                        menu={this.props.navigation && this.props.route && this.props.route.params && this.props.route.params.noMenu}
                        back
                        props={this.props} statusBarTransparent
                        // text={i18n.t('Apply.title')}
                        text={"تست"}
                        //text={item ? (item.name ? item.name : (item.title ? item.title : '')) : null}
                        //   text={i18n.t('constant.Information')}

                        headerVisibility more_menu
                        onBackPress={() => this.props.navigation.pop()}

                    />
                    <View style={{flex: 1,}}>

                        <FlatList
                            style={{marginTop: moderateScale(1)}}
                            // ItemSeparatorComponent={
                            //     <View style={{
                            //         width: '100%',
                            //         height: moderateScale(1),
                            //         backgroundColor: '#4f4f4f'
                            //     }}/>
                            // }
                            // data={comment === null || !comment ? [] : comment}
                            listKey={(item, index) => 'D' + index.toString()}

                            numColumns={1}
                            //type => 1=  , 2= , 3= , 4= ,
                            data={this.state.list}
                            //data={list}
                            renderItem={({item, index}) => {


                                return <View
                                    style={{
                                        flex: 1,
                                        marginBottom: moderateScale(4),
                                        borderRadius: moderateScale(6),
                                        borderColor: '#d0d8df',
                                        backgroundColor: Colors.white,
                                        borderWidth: moderateScale(1),
                                        overflow: 'hidden',
                                        margin: moderateScale(2),
                                        // flexDirection: 'row',
                                        //  justifyContent: 'space-between',
                                        //alignItems: 'center',
                                        padding: moderateScale(6), marginVertical: moderateScale(2)
                                    }}>

                                    <View

                                        style={{
                                            flex: 1,
                                            // margin: moderateScale(2),
                                            flexDirection: 'row',
                                            //  justifyContent: 'space-between',
                                            alignItems: 'center',
                                            //  paddingHorizontal: moderateScale(6), marginVertical: moderateScale(10)
                                        }}>

                                        <TouchableOpacity
                                            onPress={() => {

                                                if (item.type !== "success" && item.type !== "error") {
                                                    this.setType(item, index, "loading")
                                                }
                                                // this.setState({
                                                //     list: update(this.state.list, {index: {type: {$set: item === "loading" ? "success" : 'loading'}}})
                                                // })
                                                // this.setState({
                                                //     index: index,
                                                //     type: this.state.type === "loading" ? "success" : 'loading'
                                                // })
                                            }}
                                            style={{
                                                width: moderateScale(30),
                                                height: moderateScale(30),
                                                borderRadius: moderateScale(15),
                                                borderColor: this.getColor(item, index),
                                                //   backgroundColor: "#fbfbfb",
                                                borderWidth: moderateScale(1),
                                                overflow: 'hidden',
                                                padding: moderateScale(4),
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}>
                                            {
                                                item.type === "loading" ?
                                                    <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>
                                                    :
                                                    <HMIcon type={"FontAwesome"} name={"check"}
                                                                     style={{
                                                                         fontSize: moderateScale(20),
                                                                         color: this.getColor(item, index),
                                                                         textAlign: "center",
                                                                         //  padding: moderateScale(2),

                                                                     }}/>
                                            }
                                        </TouchableOpacity>
                                        <View style={{width: moderateScale(6)}}/>
                                        <View style={{flex: 1}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                text={this.getTitle(item, index)}
                                                style={{
                                                    fontSize: moderateScale(13),

                                                    color: this.getColor(item, index),
                                                    //  marginTop: moderateScale(4),
                                                    //  textAlign: "right",
                                                }}/>
                                        </View>
                                        {
                                            item.type === "error" ?
                                                null

                                                //
                                                // {/*        < TouchableOpacity
                                                //             style={{}}
                                                //             onPress={() => {
                                                //                 this.setState({
                                                //                     description: item.description,
                                                //                     visibleModal: true
                                                //                 })
                                                //             }}
                                                //         >
                                                //             <HMTextView
                                                //                 // numberOfLines={2}
                                                //                 type={"bold"}
                                                //                 // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                //                 text={"راهنما"}
                                                //                 style={{
                                                //                     fontSize: moderateScale(12),
                                                //
                                                //                     color: Colors.blue
                                                //                     //  marginTop: moderateScale(4),
                                                //                     //  textAlign: "right",
                                                //                 }}/>
                                                //         </TouchableOpacity>*/}
                                                //
                                                //
                                                : null
                                        }
                                    </View>

                                    <View style={{
                                        width: '99%',
                                        height: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.light43,
                                        marginTop: moderateScale(4)
                                    }}/>
                                    <View

                                        style={{
                                            flex: 1,
                                            // margin: moderateScale(2),
                                            flexDirection: 'row',
                                            //  justifyContent: 'space-between',
                                            alignItems: 'center',
                                            //  paddingHorizontal: moderateScale(6), marginVertical: moderateScale(10)
                                        }}>
                                        <View style={{
                                            height: '99%',
                                            width: moderateScale(1),
                                            alignSelf: 'center',
                                            backgroundColor: Colors.light43,
                                        }}/>
                                        <View style={{
                                            flex: .4,
                                            // margin: moderateScale(2),
                                            //flexDirection: 'row',
                                            //  justifyContent: 'space-between',
                                            // alignItems: 'center',
                                            //  paddingHorizontal: moderateScale(6), marginVertical: moderateScale(10)
                                        }}>

                                            <HMTextView
                                                numberOfLines={2}
                                                type={"bold"}
                                                text={"نتیجه " + item.percent + " درصد وصلی "}
                                                style={{
                                                    fontSize: moderateScale(11),
                                                    color: Colors.colorDarkText,
                                                    marginHorizontal: moderateScale(4)
                                                    //  marginTop: moderateScale(4),
                                                    //  textAlign: "right",
                                                }}/>
                                            <HMTextView
                                                numberOfLines={2}
                                                type={"bold"}
                                                text={"متوسط زمان (ms) :  " + parseInt(item.average)}
                                                //text={`متوسط زمان(ms) :   ms${item.average} ` }
                                                style={{
                                                    fontSize: moderateScale(11),
                                                    marginTop: moderateScale(8),
                                                    color: Colors.colorDarkText,
                                                    marginHorizontal: moderateScale(4)
                                                    //  marginTop: moderateScale(4),
                                                    //  textAlign: "right",
                                                }}/>
                                        </View>
                                        <View style={{
                                            flex: .6,
                                            height: "100%",
                                            // margin: moderateScale(2),
                                            flexDirection: 'row',
                                            //  justifyContent: 'space-between',
                                            //alignItems: 'center',
                                            //  paddingHorizontal: moderateScale(6), marginVertical: moderateScale(10)
                                        }}>
                                            <View style={{
                                                height: '99%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43,
                                            }}/>
                                            <View style={{
                                                flex: .25,
                                                // margin: moderateScale(2),
                                                //flexDirection: 'row',
                                                //  justifyContent: 'center',
                                                alignItems: 'center',
                                                //  paddingHorizontal: moderateScale(6), marginVertical: moderateScale(10)
                                            }}>
                                                <HMTextView
                                                    numberOfLines={1}
                                                    type={"bold"}
                                                    text={"ping 1"}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        color: Colors.blue,
                                                        marginHorizontal: moderateScale(4),
                                                        marginTop: moderateScale(2),
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>
                                                <View style={{
                                                    width: '100%',
                                                    height: moderateScale(1),
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    backgroundColor: Colors.light43,
                                                }}/>
                                                <View style={{
                                                    flex: 1,
                                                    //backgroundColor:"#e0ee62",
                                                    justifyContent: 'center',
                                                    alignItems: 'center',

                                                }}>
                                                    {
                                                        item.type1 === "loading" ?
                                                            <ActivityIndicator color={Colors.colorPrimary}
                                                                               size={"small"}/>
                                                            :
                                                            <HMTextView
                                                                numberOfLines={1}
                                                                type={"bold"}
                                                                text={item.type1 === 'error' ? "X" : item.ms1 + " ms "}
                                                                style={{
                                                                    fontSize: moderateScale(12),
                                                                    color: item.type1 === 'error' ? Colors.red : Colors.colorDarkText,
                                                                    marginHorizontal: moderateScale(4)
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                    }
                                                </View>
                                            </View>
                                            <View style={{
                                                height: '99%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43,
                                            }}/>
                                            <View style={{
                                                flex: .25,
                                                // margin: moderateScale(2),
                                                //flexDirection: 'row',
                                                //   justifyContent: 'center',
                                                alignItems: 'center',
                                                //  paddingHorizontal: moderateScale(6), marginVertical: moderateScale(10)
                                            }}>
                                                <HMTextView
                                                    numberOfLines={1}
                                                    type={"bold"}
                                                    text={"ping 2"}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        color: Colors.blue,
                                                        marginHorizontal: moderateScale(4),
                                                        marginTop: moderateScale(2),
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>
                                                <View style={{
                                                    width: '100%',
                                                    height: moderateScale(1),
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    backgroundColor: Colors.light43,
                                                }}/>
                                                <View style={{
                                                    flex: 1,
                                                    //backgroundColor:"#e0ee62",
                                                    justifyContent: 'center',
                                                    alignItems: 'center',

                                                }}>
                                                    {
                                                        item.type2 === "loading" ?
                                                            <ActivityIndicator color={Colors.colorPrimary}
                                                                               size={"small"}/>
                                                            :
                                                            <HMTextView
                                                                numberOfLines={1}
                                                                type={"bold"}
                                                                text={item.type2 === 'error' ? "X" : item.ms2 + " ms "}
                                                                style={{
                                                                    fontSize: moderateScale(12),
                                                                    color: item.type2 === 'error' ? Colors.red : Colors.colorDarkText,
                                                                    marginHorizontal: moderateScale(4)
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                    }
                                                </View>
                                            </View>
                                            <View style={{
                                                height: '99%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43,
                                            }}/>
                                            <View style={{
                                                flex: .25,
                                                // margin: moderateScale(2),
                                                //flexDirection: 'row',
                                                // justifyContent: 'center',
                                                alignItems: 'center',
                                                //  paddingHorizontal: moderateScale(6), marginVertical: moderateScale(10)
                                            }}>
                                                <HMTextView
                                                    numberOfLines={1}
                                                    type={"bold"}
                                                    text={"ping 3"}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        color: Colors.blue,
                                                        marginHorizontal: moderateScale(4),
                                                        marginTop: moderateScale(2),
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>
                                                <View style={{
                                                    width: '100%',
                                                    height: moderateScale(1),
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    backgroundColor: Colors.light43,
                                                }}/>
                                                <View style={{
                                                    flex: 1,
                                                    //backgroundColor:"#e0ee62",
                                                    justifyContent: 'center',
                                                    alignItems: 'center',

                                                }}>
                                                    {
                                                        item.type3 === "loading" ?
                                                            <ActivityIndicator color={Colors.colorPrimary}
                                                                               size={"small"}/>
                                                            :
                                                            <HMTextView
                                                                numberOfLines={1}
                                                                type={"bold"}
                                                                text={item.type3 === 'error' ? "X" : item.ms3 + " ms "}
                                                                style={{
                                                                    fontSize: moderateScale(12),
                                                                    color: item.type3 === 'error' ? Colors.red : Colors.colorDarkText,
                                                                    marginHorizontal: moderateScale(4)
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                    }
                                                </View>
                                            </View>
                                            <View style={{
                                                height: '99%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43,
                                            }}/>
                                            <View style={{
                                                flex: .25,
                                                // margin: moderateScale(2),
                                                //flexDirection: 'row',
                                                // justifyContent: 'center',
                                                alignItems: 'center',
                                                //  paddingHorizontal: moderateScale(6), marginVertical: moderateScale(10)
                                            }}>
                                                <HMTextView
                                                    numberOfLines={1}
                                                    type={"bold"}
                                                    text={"ping 4"}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        color: Colors.blue,
                                                        marginHorizontal: moderateScale(4),
                                                        marginTop: moderateScale(2),
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>
                                                <View style={{
                                                    width: '100%',
                                                    height: moderateScale(1),
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    backgroundColor: Colors.light43,
                                                }}/>
                                                <View style={{
                                                    flex: 1,
                                                    //backgroundColor:"#e0ee62",
                                                    justifyContent: 'center',
                                                    alignItems: 'center',

                                                }}>
                                                    {
                                                        item.type4 === "loading" ?
                                                            <ActivityIndicator color={Colors.colorPrimary}
                                                                               size={"small"}/>
                                                            :
                                                            <HMTextView
                                                                numberOfLines={1}
                                                                type={"bold"}
                                                                text={item.type4 === 'error' ? "X" : item.ms4 + " ms "}
                                                                style={{
                                                                    fontSize: moderateScale(12),
                                                                    color: item.type4 === 'error' ? Colors.red : Colors.colorDarkText,
                                                                    marginHorizontal: moderateScale(4)
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                    }
                                                </View>
                                            </View>
                                            <View style={{
                                                height: '99%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43,
                                            }}/>

                                        </View>
                                    </View>
                                    <View style={{
                                        width: '99%',
                                        height: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.light43,
                                    }}/>
                                </View>

                            }}


                        />

                    </View>
                    {/* <TouchableOpacity
                        onPress={() => {
                            this.setType(this.state.list[0], 0, "loading")

                        }}
                        style={{
                            width: '96%',
                            height: moderateScale(33),
                            backgroundColor: Colors.colorSecondPrimary,
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'center',
                            flexDirection: 'row',
                            marginTop: moderateScale(4),
                            marginHorizontal: moderateScale(4),
                            borderRadius: moderateScale(8),
                            marginVertical: moderateScale(4)
                        }}>

                        <FontAwesomeIcon name={"check-circle"}
                                         style={{
                                             fontSize: moderateScale(20),
                                             color: Colors.white,
                                             textAlign: "center",
                                             padding: moderateScale(4),

                                         }}/>

                        <HMTextView
                            numberOfLines={1}
                            type={"bold"}
                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                            text={"آغاز تست"}
                            style={{
                                fontSize: moderateScale(14),
                                color: Colors.white,
                                marginHorizontal: moderateScale(4)
                                //  marginTop: moderateScale(4),
                                //  textAlign: "right",
                            }}/>


                    </TouchableOpacity>*/}
                {/*    <Modal
                        isVisible={this.state.visibleModal}
                        backdropColor={Colors.black}
                        backdropOpacity={0.5}
                        animationIn="zoomInDown"
                        animationOut="zoomOutUp"
                        animationInTiming={600}
                        animationOutTiming={600}
                        backdropTransitionInTiming={600}
                        backdropTransitionOutTiming={600}
                        //style={{height: '60%'}}
                        onBackdropPress={this.hiddenModal}
                        onBackButtonPress={this.hiddenModal}
                    >

                        <View style={{height: "90%", backgroundColor: Colors.white}}>
                            <View style={{
                                width: '100%',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginVertical: moderateScale(4)
                            }}>
                                <HMTextView
                                    // numberOfLines={2}
                                    type={"bold"}
                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                    text={"راهنما"}
                                    style={{
                                        fontSize: moderateScale(14),

                                        color: Colors.blue
                                        //  marginTop: moderateScale(4),
                                        //  textAlign: "right",
                                    }}/>
                            </View>
                            <HMTextView
                                // numberOfLines={2}
                                type={"bold"}
                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                text={this.state.description}
                                style={{
                                    fontSize: moderateScale(13),

                                    color: Colors.colorDarkText,
                                    marginTop: moderateScale(15)
                                    //  marginTop: moderateScale(4),
                                    //  textAlign: "right",
                                }}/>
                        </View>
                    </Modal>*/}
                </KeyboardAvoidingView>
            </View>
        );
    }

    async setType(item, index, type) {
        if(this._isMounted){

            const newList = container.state.list.slice() //copy the array
            newList[index].type = type
            newList[index].type1 = type
            newList[index].type2 = type
            newList[index].type3 = type
            newList[index].type4 = type
            container.setState({list: newList}) //set the new state
            let ms1 = null;
            let ms2 = null;
            let ms3 = null;
            let ms4 = null;
            let sum_ms = 0;
            let count = 0;
            let addressOld = item.address;
            /*   try {
                   /!**
                    *
                    * Get RTT (Round-trip delay time)
                    *
                    * @static
                    * @param {string} ipAddress - For example : 8.8.8.8
                    * @param {Object} option - Some optional operations
                    * @param {number} option.timeout - timeout
                    * @returns
                    * @memberof Ping
                    *!/
                   ms1 = await Ping.start(item.address, {timeout:1000});

                   ms2 = await Ping.start(item.address, {timeout:1000});

                   ms3 = await Ping.start(item.address, {timeout:1000});

                   ms4 = await Ping.start(item.address, {timeout:1000});
                   newList[index].type = "success"
                   container.setState({list: newList}) //set the new state
               } catch (error) {

                   newList[index].type = "error"
                   container.setState({list: newList}) //set the new state
               }*/
            if(this._isMounted)
            try {
                ms1 = await Ping.start(item.address, {timeout:1000});

                newList[index].ms1 = ms1
                sum_ms += ms1;
                count += 1;
                newList[index].type1 = "success"
                container.setState({list: newList}) //set the new state
            } catch (error) {
                newList[index].ms1 = ms1;
                newList[index].type1 = "error";

                container.setState({list: newList}) //set the new state
            }

            if(this._isMounted)
            try {
                ms2 = await Ping.start(item.address, {timeout:1000});
                newList[index].ms2 = ms2;
                sum_ms += ms2;
                count += 1;

                newList[index].type2 = "success";
                container.setState({list: newList}) //set the new state
            } catch (error) {

                newList[index].ms2 = ms2;
                newList[index].type2 = "error";
                container.setState({list: newList}) //set the new state
            }

            if(this._isMounted)
            try {

                ms3 = await Ping.start(item.address, {timeout:1000});
                newList[index].ms3 = ms3;
                sum_ms += ms3;
                count += 1;

                newList[index].type3 = "success";
                container.setState({list: newList}) //set the new state
            } catch (error) {

                newList[index].ms3 = ms3;
                newList[index].type3 = "error";
                container.setState({list: newList}) //set the new state
            }

            if(this._isMounted)
            try {
                ms4 = await Ping.start(item.address, {timeout:1000});
                newList[index].ms4 = ms4;
                sum_ms += ms4;
                count += 1;

                newList[index].type4 = "success";
                // container.setState({list: newList}) //set the new state
            } catch (error) {

                newList[index].ms4 = ms4;

                newList[index].type4 = "error";
                //  container.setState({list: newList}) //set the new state
            }
            newList[index].type = ms1 || ms2 || ms3 || ms4 ? "success" : "error";
            newList[index].average = sum_ms / 4;
            newList[index].percent = count * 25;
            if (index === 0 && count === 0) {
                newList[index].address = "192.168.0.1"

                newList[index].error = "اتصال با مودم برقرار نیست (ping 192.168.0.1)";
                newList[index].message = "دسترسی به مودم  (ping 192.168.0.1) Wi-Fi";
                newList[index].success = "اتصال با مودم برقرار است (ping 192.168.0.1)";
            }

            container.setState({list: newList},

                async () => {

                    if (index < container.state.list.length - 1) {
                        if (index === 0 && count === 0 && addressOld == "192.168.1.1") {
                            container.setType(container.state.list[0], 0, "loading")

                        }
                        else
                            container.setType(container.state.list[index + 1], index + 1, "loading")

                    }

                    if (index === container.state.list.length - 1) {
                        // const {
                        //     receivedNetworkSpeed,
                        //     sendNetworkSpeed,
                        //     receivedNetworkTotal,
                        //     sendNetworkTotal
                        // } = await Ping.getTrafficStats();
                        //     sendNetworkSpeed,
                        //     receivedNetworkTotal,
                        //     sendNetworkTotal);

                    }

                }
            ) //set the new state

        }


    }

    hiddenModal() {
        container.setState({
                visibleModal: false
            },
            () => {
            })
    }

    // ping(){
    //
    // }

    getTitle(item, index) {
        //     if (index === container.state.index)
        switch (item.type) {
            case  "loading":

                return item.message;

            case  "error":

                return item.error;
            case  "success":

                return item.success;

            default:
                return item.message;
        }
        // else
        //     return Colors.gray
    }

    getColor(item, index) {
        //     if (index === container.state.index)
        switch (item.type) {
            case  "loading":

                return Colors.gray;

            case  "error":

                return Colors.red;
            case  "success":

                return Colors.green;
            default:
                return Colors.gray
        }
        // else
        //     return Colors.gray
    }
}

const styles = StyleSheet.create({
    containerBack: {

        flexDirection: "row",
        //   alignItems: Platform.OS === "ios" ? "flex-end" : "center",
        // justifyContent: "space-between",
        height: Platform.OS === "ios" ? moderateScale(70) : moderateScale(50),
        paddingBottom: Platform.OS === "ios" ? moderateScale(15) : 0,
        paddingHorizontal: moderateScale(10)
    },
    container: {
        backgroundColor: Colors.backgroundColorDarker,
        flexDirection: "row",
        // alignItems: Platform.OS === "ios" ? "flex-end" : "center",
        // justifyContent: "flex-end",
        height: Platform.OS === "ios" ? moderateScale(75) : moderateScale(55),
        paddingBottom: Platform.OS === "ios" ? moderateScale(15) : 0,
        paddingHorizontal: moderateScale(10)

    },
    rowContainer: {
        flexDirection: "row",
    }
});


const mapStateToProps = (state) => {

    return {
        //  data_splash: state.reducerSplashGetAllData
    }
}
const mapDispatchToProps = dispatch => {
    return {
        // callServiceSubCart: (data) => dispatch(serviceActionSubCart(data)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TestConnectionScreen);
